<!--
// app/components/Shared/RibbonBanner.vue
-->
<script setup lang="ts">
import ContextLogoCrown from "~/components/context-shared/ContextLogoCrown.vue";

type Props = {
  text: string;
};

defineProps<Props>();
</script>

<template>
  <div class="bg-primary py-2 flex items-center justify-center w-full min-w-max">
    <div
      v-for="i in 12"
      :key="i"
      class="flex items-center justify-center px-1 font-[HeadingNow] uppercase text-lg leading-none gap-2 text-black tracking-[20%] ltr:-translate-x-20 rtl:translate-x-20"
    >
      <context-logo-crown width="20" height="20" />
      {{ text }}
    </div>
  </div>
</template>
